import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "../layout/Layout.vue";

Vue.use(VueRouter);

const routes = [
  { path: "/login", name: "Login", component: () => import("../views/Login.vue") },
  {
    path: "/",
    component: Layout,
    redirect: "/users",
    children: [
      { path: "users", name: "Users", component: () => import("../views/user/UserList.vue"), meta: { title: "用户管理" } },
      { path: "users/:id", name: "UserDetail", component: () => import("../views/user/UserDetail.vue"), meta: { title: "用户详情" } },
      { path: "point-records", name: "PointRecords", component: () => import("../views/pointRecord/PointRecordList.vue"), meta: { title: "积分记录" } },
      { path: "drama-unlocks", name: "DramaUnlocks", component: () => import("../views/dramaUnlock/DramaUnlockList.vue"), meta: { title: "短剧解锁记录" } },
      { path: "settings", name: "Settings", component: () => import("../views/setting/SystemSetting.vue"), meta: { title: "系统设置" } },
      { path: "tasks", name: "Tasks", component: () => import("../views/task/TaskManage.vue"), meta: { title: "每日任务管理" } },
      { path: "task-stats", name: "TaskStats", component: () => import("../views/task/TaskStats.vue"), meta: { title: "任务完成情况" } },
      { path: "open-clients", name: "OpenClients", component: () => import("../views/openClient/OpenClientList.vue"), meta: { title: "第三方接入" } },
      { path: "app-versions", name: "AppVersions", component: () => import("../views/version/VersionManage.vue"), meta: { title: "版本管理" } },
    ],
  },
];

const router = new VueRouter({ mode: "history", routes });

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("admin_token");
  if (to.path === "/login") {
    next();
  } else if (!token) {
    next("/login");
  } else {
    next();
  }
});

export default router;
